import { render } from "./AnonymousPageFooter.vue?vue&type=template&id=21650a66&scoped=true"
import script from "./AnonymousPageFooter.vue?vue&type=script&lang=js"
export * from "./AnonymousPageFooter.vue?vue&type=script&lang=js"

import "./AnonymousPageFooter.vue?vue&type=style&index=0&id=21650a66&lang=css&scoped=true"
import "./AnonymousPageFooter.vue?vue&type=style&index=1&id=21650a66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21650a66"]])

export default __exports__